import baseMethods from "../baseMethods";
import 'whatwg-fetch';
import utils from "../../libs/utils";

let commodity = {};
let siteCode = utils.localStorageGet('siteCode');
let base_url_lgc = baseMethods.lgc_api_proxy + '/sobeyMallProduct';
let base_url_wcy = baseMethods.wcy_api_proxy + '/sobeyMallOrder';

/*获取商品分类*/
commodity.commodity_categories = (parentId) => {
    let cate_param = {
        parentId: parentId ? parentId : '0'
    };
    let myURL = base_url_lgc + `/V1/categorys/list`;
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, cate_param).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取商品列表*/
commodity.commodityListPage = (uuid) => {
    let myURL = base_url_lgc + `/V1/products/list?category.uuid=${uuid}`;
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取商品详情*/
commodity.commodity_details = (newCode) => {

    let myURL = base_url_lgc + `/V1/products/${newCode}`;

    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取图片文件真实路径*/
commodity.commodity_media_address = (mediaId) => {

    let myURL = base_url_lgc + `/V1/medias?mediaId=${mediaId}`;

    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取商品亮点信息*/
commodity.commodity_bright_spot = (productId) => {

    let myURL = base_url_lgc + `/V1/bright-spot?productId=${productId}`;

    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取功能详情信息*/
commodity.commodity_functions = (productId) => {
    let myURL = base_url_lgc + `/V1/functions?productId=${productId}`;

    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取合作案例信息*/
commodity.commodity_cooperation_case = (productId) => {

    let myURL = base_url_lgc + `/V1/cooperation-case?productId=${productId}`;

    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};


/*获取按量开通信息*/
commodity.commodity_metric_list = (productId) => {
    let newHeader = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
    });
    let myURL = base_url_lgc + `/V1/metric/list?productId=${productId}`;
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, newHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*马上开通*/
commodity.commodity_activate_service = (param) => {
    let newHeader = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
    });
    param.siteCode = siteCode;
    let myURL = base_url_wcy + `/V1/service`;
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, param, newHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*收藏已开通商品*/
commodity.commodity_collect_service = (param) => {
    let active_userCode = utils.localStorageGet('lingyun_login_usercode');
    let myParam = {
        productId: param['productId'],
        userCode: active_userCode,
        // siteCode
    };
    let newHeader = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
    });
    let myURL = base_url_lgc + `/V1/favorite`;
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, myParam, newHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*查询我的服务*/
commodity.commodity_my_service = (productId) => {
    let active_userCode = utils.localStorageGet('lingyun_login_usercode');
    let myParam = {
        productId: productId,
        accountId: active_userCode,
        serviceStatus: '1',
        siteCode,
    };
    let newHeader = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
    });
    let myURL = base_url_wcy + `/V1/service/pages?page=1&size=600`;
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, myParam, newHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*是否已经购买某个商品*/
commodity.commodity_purchased_or_not = (param) => {

    let myURL = base_url_wcy + `/V1/service/isOpened?accountId=${param.accountId}&productId=${param.productId}`;
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            if (res) {
                resolve(res);
            } else {
                resolve([]);
            }
        }).catch((err) => {
            resolve([]);
        })
    })

};


/*查询商品套餐包*/
commodity.commodity_package_info = (productId) => {
    let myParam = {
        productId: productId,
    };
    let newHeader = new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
    });
    let myURL = base_url_lgc + '/V1/packages/list';
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, myParam, newHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};


export default commodity;



// WEBPACK FOOTER //
// ./src/api/commodity/commodity.js